import CleExamManager from './exam/cleExamManager'
import CleExamDetail from "./exam/examDetail/examDetail";

export {
  CleExamManager,
  CleExamDetail,
}
